

export const FAQ_LANDING_REQUEST =         "FAQ_LANDING_REQUEST";
export const FAQ_LANDING_REQUEST_SUCCESS = "FAQ_LANDING_SUCCESS";
export const FAQ_LANDING_REQUEST_FAIL =    "FAQ_LANDING_FAIL"
